module.exports = __webpack_public_path__ + "img/1517999029.7d7e5ceb.jpg";